import { render, staticRenderFns } from "./reviewContentsChat.vue?vue&type=template&id=d57bfbba&"
import script from "./reviewContentsChat.vue?vue&type=script&lang=js&"
export * from "./reviewContentsChat.vue?vue&type=script&lang=js&"
import style0 from "./reviewContentsChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports